export const websiteSelectList = [
  {
    key: '0',
    label: 'L’alerte immo',
    value: 0,
  },
  {
    key: '1',
    label: 'La cartographie',
    value: 1,
  },
  {
    key: '2',
    label: 'La newsletter et les offres partenaires',
    value: 2,
  },
  {
    key: '3',
    label: 'Mon espace perso SeLoger.com',
    value: 3,
  },
  {
    key: '4',
    label: 'La recherche d’un bien',
    value: 4,
  },
  {
    key: '5',
    label: 'La location d’un bien',
    value: 5,
  },
  {
    key: '6',
    label: 'La vente d’un bien',
    value: 6,
  },
  {
    key: '7',
    label: 'Problèmes techniques sur le site',
    value: 7,
  },
  {
    key: '8',
    label: 'Données Personnelles : Exercez vos Droits',
    value: 8,
  },
  {
    key: '9',
    label: 'Fraude',
    value: 9,
  },
  {
    key: '10',
    label: 'Profil locataire',
    value: 10,
  },
  {
    key: '11',
    label: 'Autres',
    value: 11,
  },
]
export const professionalSelectList = [
  {
    key: '12',
    label: 'Professionnel de l’immobilier - Régie publicitaire',
    value: 12,
  },
  {
    key: '13',
    label: 'Professionnel de l’immobilier - Offres commerciales',
    value: 13,
  },
  {
    key: '14',
    label: 'Professionnel de l’immobilier - Devenir client',
    value: 14,
  },
  {
    key: '15',
    label: 'Professionnel de l’immobilier - Partenariats',
    value: 15,
  },
]

export const getSubjectText = subjectKey => [...websiteSelectList, ...professionalSelectList].find(el => el.value === subjectKey).label

export function getSubReason(subjectId) {
  switch (subjectId) {
    case 0:
      return 'Information / dysfonctionnement alerte immo'
    case 1:
    case 2:
    case 4:
    case 5:
    case 7:
      return 'Informations site web'
    case 8:
      return 'Suppression de données'
    case 9:
      return 'Signalements'
    case 10:
      return 'Profil locataire'
    case 12:
    case 15:
      return 'Publicité - régie'
    case 13:
    case 14:
      return 'Prospects / Suspects'
    case 11:
    case 6:
    default:
      return 'Autres'
  }
}

export function getReason(subjectId) {
  switch (subjectId) {
    case 0:
      return 'Mail'
    case 6:
      return 'FSBO'
    case 1:
    case 2:
    case 4:
    case 5:
    case 7:
      return 'Formation'
    case 8:
      return 'RGPD'
    case 9:
      return 'Fraude'
    case 10:
      return 'Administratif'
    case 15:
    case 12:
      return 'Info produit'
    case 13:
    case 14:
      return 'Commercial'
    default:
      return 'Divers'
  }
}
